<template>
  <v-card flat>
    <custom-tabs
      v-model="activeTab"
      :tab-items="tabs"
      :window-items="tabs"
      class="my-5 mx-2"
      grow
    >
      <template #item="{ item }">
        <v-card flat color="transparent">
          <v-card-text>
              <component 
              :is="item.component"
              @success="handleSuccess"
              @input="handleInput"
            />
          </v-card-text>
        </v-card>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import QrCreateComponent from './PrePurchaseCreate.vue';
import QrListComponent from './PrePurchaseList.vue';

export default {
  name: 'PrePurchaseManager',
  components: {
    QrCreateComponent,
    QrListComponent
  },
  created(){
      const savedTab = sessionStorage.getItem('activeQrTab');
    if (savedTab !== null) {
      this.activeTab = parseInt(savedTab, 10);
    }

  },
   watch: {
    activeTab(newVal) {
      sessionStorage.setItem('activeQrTab', newVal);
    }
  },
  methods: {
    handleSuccess() {
      this.activeTab = 1;
    },
    handleInput(val) {
    }
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { 
          text: 'ساخت کیوآر کد', 
          icon: 'qrcode-plus',    
          component: 'QrCreateComponent' 
        },
        { 
          text: 'لیست کیوآر کدها', 
          icon: 'format-list-bulleted', 
          component: 'QrListComponent' 
        }
      ]
    };
  }
};
</script>
